import axios from 'axios';
const url = process.env.REACT_APP_BASE_API_URL;

export async function loginUser (auth) {
    const headers = { 'Content-Type': 'application/json'}
    return await axios.post(url + '/v1/authentication', auth, {headers});
}
